import PropTypes from 'prop-types';

export const OfficialShape = {
    id: PropTypes.string.isRequired,
    memberId: PropTypes.number,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    countryId: PropTypes.number.isRequired,
    itfId: PropTypes.string,
    role: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
};

export const ClubOfficialMemberShape = {
    memberId: PropTypes.number,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    countryId: PropTypes.number.isRequired,
    country: PropTypes.string.isRequired,
};

export const CountryShape = {
    description: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
};
